import "@hotwired/turbo-rails";
import "./controllers";

import * as Lexxy from '@37signals/lexxy'

Lexxy.configure({
  default: {
    attachments: false,
    toolbar: {
      upload: "none",
    },
    highlight: {
      buttons: {},
    },
  },
});
